import { useAuthStore } from '@/stores/retailer/auth.js'
import { handleMaintenance } from './handleMaintenance.js'
import { createHttpClient } from './httpClient.js'

export const RetailerApiClient = createHttpClient({
  baseURL: import.meta.env.VITE_BACKEND_RETAILER_URL,
  requestInterceptor: () => {
    const authStore = useAuthStore()
    const token = authStore.getToken

    if (token) {
      return { Authorization: `Bearer ${token}` }
    }

    return {}
  },
  errorInterceptor: (error, retry) => {
    const authStore = useAuthStore()

    if (error.response?.status === 401 && authStore.getToken) {
      // Sync cross-tab token and replay the request so the user's action isn't dropped.
      if (authStore.syncFromStorage()) {
        return retry()
      }
      authStore.handleSessionExpired()
      throw error
    }

    if (error.response?.status === 503) {
      handleMaintenance()
    }

    throw error
  }
})
